// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__qFszK","noInteraction":"EventWrapper_noInteraction__OT7R4"};